import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      const res = await subscribeNewsletter({ email, source: "footer" });
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="newsletter-form"
      className={`flex ${compact ? "flex-col sm:flex-row" : "flex-col sm:flex-row"} gap-2`}
    >
      <Input
        type="email"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid="newsletter-email-input"
        className="bg-paper border-[rgba(74,63,57,0.18)] focus-visible:ring-[#2F6F5B] focus-visible:ring-offset-0"
      />
      <Button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-button"
        className="bg-[#C86A4A] hover:bg-[#B85F41] text-white rounded-xl transition-colors"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
      </Button>
    </form>
  );
}
